import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './globals.css';
import './CallWidget.css';

// Import components
import Header from './components/Layout/HeaderNew';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePageNew';
import VoiceAssistant from './components/VoiceAssistant/VoiceAssistant';
import VoicebotNotice from './components/VoicebotNotice';
import { SkipToContent } from './lib/accessibility';
import { getTenantFromPath } from './config/tenants';

// Redirect component for root path
function RootRedirect() {
  useEffect(() => {
    window.location.href = 'https://www.reasoningcompany.com/services/ai-front-desk';
  }, []);
  
  return null;
}

// Wrapper component to pass tenant config to children
function TenantWrapper() {
  const location = useLocation();
  const tenant = getTenantFromPath(location.pathname);
  
  return (
    <div className="App">
      <SkipToContent />
      <Header tenant={tenant} />
      
      <main id="main-content" className="main-content">
        <HomePage tenant={tenant} />
      </main>

      <Footer tenant={tenant} />
      <VoiceAssistant tenant={tenant} />
      <VoicebotNotice />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Healthcare routes */}
        <Route path="/healthcare/neuropsych" element={<TenantWrapper />} />
        <Route path="/healthcare/amsterdam-dental" element={<TenantWrapper />} />
        <Route path="/healthcare" element={<TenantWrapper />} />
        
        {/* Lawyers route */}
        <Route path="/lawyers" element={<TenantWrapper />} />
        
        {/* Legacy routes - redirect to new paths */}
        <Route path="/neuropsych" element={<TenantWrapper />} />
        <Route path="/amsterdam-dental" element={<TenantWrapper />} />
        
        {/* Default route - redirect to main website */}
        <Route path="/" element={<RootRedirect />} />
        
        {/* Catch-all route for any future tenants */}
        <Route path="/:tenant" element={<TenantWrapper />} />
      </Routes>
    </Router>
  );
}

export default App;
